import { useState } from 'react';
import { Crop, Loader2, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';
import { adminApi } from '@/lib/adminApi';

const LABELS = { changed: ['Ausgerichtet', 'is-ok'], aligned: ['Passte schon', 'is-muted'], unsure: ['Umriss nicht sicher erkannt – bitte prüfen', 'is-warn'], no_reference: ['Kein Hauptfoto als Datei', 'is-warn'], conflict: ['Artikel wurde gleichzeitig bearbeitet – erneut starten', 'is-warn'], failed: ['Fehler', 'is-warn'] };

const ResultList = ({ rows }) => {
  const count = s => rows.filter(r => r.status === s).length;
  return <>
    <p className="align-all-summary" data-testid="align-all-summary">{count('changed')} ausgerichtet · {count('aligned')} passten schon · {rows.length - count('changed') - count('aligned')} bitte prüfen</p>
    <div className="align-all-rows" data-testid="align-all-rows">{rows.map((r, i) => <div key={i} className={`align-all-row ${LABELS[r.status]?.[1] || ''}`} data-testid={`align-all-row-${i}`}><strong>{r.product}</strong><span>{r.view} · {r.color}</span><em>{LABELS[r.status]?.[0] || r.status}</em></div>)}</div>
    {!rows.length && <p className="admin-measure-note">Keine Artikel mit eigenen Farbfotos gefunden.</p>}
  </>;
};

export const AlignAllButton = ({ onDone }) => {
  const [open, setOpen] = useState(false), [job, setJob] = useState(null), [error, setError] = useState('');
  const running = job?.status === 'running';
  const start = async () => {
    setError(''); setJob({ status: 'running', rows: [], progress: [0, 0] });
    try {
      const { job: started } = await adminApi('/product-views/align-all', { method: 'POST' });
      for (;;) {
        await new Promise(r => setTimeout(r, 2000));
        const { job: state } = await adminApi(`/product-views/jobs/${started.id}`);
        setJob(state);
        if (state.status !== 'running') { if (state.error) setError(state.error); onDone(); break; }
      }
    } catch (e) { setError(e.message); setJob(null); }
  };
  return <>
    <Button variant="outline" onClick={() => { setOpen(true); setJob(null); setError(''); }} data-testid="admin-align-all"><Crop size={17} />Alle Artikel ausrichten</Button>
    <Dialog open={open} onOpenChange={v => { if (!running) setOpen(v); }}>
      <DialogContent className="align-all-dialog" data-testid="align-all-dialog">
        <DialogTitle>Farbfotos aller Artikel ausrichten</DialogTitle>
        <DialogDescription>Jedes Farbfoto wird auf Größe und Lage des Hauptfotos seiner Ansicht gebracht – damit sitzt die Druck- bzw. Gravurfläche im Designer bei jeder Farbe gleich. Gilt für alle Artikel, auch inaktive. Fotos, die schon passen, bleiben unverändert.</DialogDescription>
        {error && <p className="studio-error" role="alert" data-testid="align-all-error">{error}</p>}
        {job && running && <p className="align-all-progress" data-testid="align-all-progress"><Loader2 size={16} className="spin" />Artikel {job.progress?.[0] || 0} von {job.progress?.[1] || '…'} · {job.rows?.length || 0} Farbfotos geprüft</p>}
        {job && !running && <ResultList rows={job.rows || []} />}
        <div className="align-all-actions">
          {!job && <Button onClick={start} data-testid="align-all-start"><Crop size={16} />Jetzt ausrichten</Button>}
          <Button variant="outline" disabled={running} onClick={() => setOpen(false)} data-testid="align-all-close"><X size={16} />{job && !running ? 'Schließen' : 'Abbrechen'}</Button>
        </div>
      </DialogContent>
    </Dialog>
  </>;
};
